import Loader from "../../loader";
import { useEffect } from "react";
import NoRecord from "../../NoRecord";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubscriptions } from "../../../redux/actions/authAction";

const Subscription = () => {
  const dispatch = useDispatch();
  const { myPlanDetail, isLoading } = useSelector((state) => state.authReducer);

  useEffect(() => {
    dispatch(fetchSubscriptions());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <h3 class="ct_fs_32 ct_switzer_bold mb-5">My Subscription</h3>
      {myPlanDetail?.plan?.plan_name ? (
        <div class="et-plan-card">
          <div class="et-plan-info ct_w_100_575">
            <h2>SecurPoint+</h2>
            <button
              class="ct_green_bnt et-access-btn mt-4 px-3 ct_w_100_575"
              data-bs-target="#mobileAppModal"
              data-bs-toggle="modal"
            >
              Access more for less
            </button>
          </div>

          <div class="et-plan-status">
            <p>
              Current plan:{" "}
              <strong>{myPlanDetail?.plan?.plan_name || ""}</strong>
            </p>
            <span>Upgrade your plan!</span>
          </div>
        </div>
      ) : (
        <NoRecord />
      )}
    </>
  );
};

export default Subscription;
